// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, throwError } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { Contact, ContactHelper } from '../../models/b2b/contact';
import { ContactFormResponseHelper } from '../../models/b2b/contactFormResponse';

// Pipe
import { DatePipe } from '@angular/common';
import { CallMeHelper, CallMe } from '../../models/b2b/callMe';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class SoledadContactService {
    constructor(
        private api: ApiService,
        private datePipe: DatePipe,
    ) {}

    /**
     * Get contacts from api
     *
     * @param
     *
     * @return void
     */
    getContact(): Observable<Contact> {
        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_Contacto').pipe(
            validateApiResponse('Error obteniendo contacto'),
            map((contact: any) => {
                return ContactHelper.transformFromAPI(contact[0]);
            }),
        );
    }

    /**
     * Get Form Response from api
     *
     * @param
     *
     * @return void
     */
    getContactFormResponse(consulta: string, email: string): Observable<ContactFormResponseHelper> {
        const params = [];
        params['CONSULTA'] = consulta;
        params['EMAIL'] = email;

        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_UsuariosConsulta', params).pipe(
            validateApiResponse('Error obteniendo respuesta de consulta' + '. Params: ' + JSON.stringify(params)),
            map((responses: any[]) => {
                return responses.map((response: any) => ContactFormResponseHelper.transformFromApi(response));
            }),
        );
    }

    /**
     * Contact callMeBack from api
     *
     * @param
     *
     * @return void
     */
    callMeBack(telefono: number, hora: string, fecha: string): Observable<CallMe> {
        // console.log('callMeBack', telefono, hora, fecha);

        const params = [];

        params['TELEFONO'] = telefono;

        if (hora)
            // params['MINUTOS'] = hora;
            params['HORA_LLAMADA'] = hora;
        // hora.toString('HH:mm');

        if (fecha) {
            params['FECHA_LLAMADA'] = this.datePipe.transform(fecha, 'yyyyMMdd');
        }

        // console.log(params);

        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_UsuariosLlamame', params).pipe(
            validateApiResponse('Error obteniendo llamame' + '. Params: ' + JSON.stringify(params)),
            map((res) => {
                return res.map((row) => CallMeHelper.transformFromApi(row));
            }),
        );
    }
}
